<rt-group
  [class.editable]="editable"
  [class.horizontal]="direction === 'horizontal'"
  [class.vertical]="direction === 'vertical'"
>
  <rt-add-new-button
    *ngIf="editable"
    variant="rounded"
    class="action more"
    [rtcAnalyticsTrack]="analyticsEvent ? analyticsEvent : undefined"
    (click)="onAddClick()"
    iconName="add-circle-outline"
    shape="round"
    size="medium"
    margin-right-small-xx
  >
  </rt-add-new-button>
  <rt-group
    *ngIf="admins.length > 0"
    [class.stacked]="stacked"
    [class.horizontal]="direction === 'horizontal'"
    [class.vertical]="direction === 'vertical'"
    [class.wrap]="multiline"
    [class.grid-vertical-margin]="multiline"
    [ngClass]="'spacing--' + spacing"
    (click)="onAvatarsClick(); stopPropagation($event); $event.preventDefault()"
    class="avatars keep-radius"
  >
    <ng-container *ngIf="!isRole">
      <rt-avatar
        *ngFor="let admin of visibleAssignments(); trackBy: trackByAdmin"
        [rtTooltip]="
          renderAdminTooltip ? renderAdminTooltip(admin) : admin.firstName + ' ' + admin.lastName
        "
        [rtTooltipPosition]="tooltipPosition"
        [rtTooltipMaxWidth]="tooltipMaxWidth"
        [rtTooltipWordWrap]="tooltipWordWrap"
        [type]="'image'"
        [size]="avatarSize ? avatarSize : 'base'"
        [shape]="avatarShape ? avatarShape : 'oval'"
        [imageSrc]="admin.photoThumbUrl"
        [isOnline]="admin.isOnline!"
      >
      </rt-avatar>
    </ng-container>

    <ng-container *ngIf="isRole">
      <rt-avatar
        *ngFor="let admin of visibleAssignments(); trackBy: trackByAdmin"
        [rtTooltip]="$any(admin).name"
        [rtTooltipPosition]="tooltipPosition"
        [rtTooltipMaxWidth]="tooltipMaxWidth"
        [rtTooltipWordWrap]="tooltipWordWrap"
        [type]="'initials'"
        [size]="avatarSize ? avatarSize : 'base'"
        [shape]="avatarShape ? avatarShape : 'oval'"
        [fullName]="$any(admin).name"
        [backgroundColor]="'gray'"
      >
      </rt-avatar>
    </ng-container>

    <rt-icon-button
      *ngIf="hasMore()"
      size="small"
      shape="round"
      variant="secondary"
      iconName="more-horiz"
      #moreButton
      class="has-more default"
      [rtTooltip]="renderOtherAdminsTooltip ? renderOtherAdminsTooltip(otherAdmins) : null"
      [rtTooltipTemplate]="renderOtherAdminsTooltip ? null : defaultHasMoreTooltipTemplate"
      [rtTooltipPosition]="tooltipPosition"
      [rtTooltipMaxWidth]="tooltipMaxWidth"
      [rtTooltipWordWrap]="tooltipWordWrap"
      (click)="moreClick.emit()"
    >
    </rt-icon-button>
  </rt-group>
</rt-group>

<ng-template #defaultHasMoreTooltipTemplate>
  <div class="tooltip-list">
    <div *ngFor="let admin of otherAdmins; trackBy: trackByAdmin" class="tooltip-list-item">
      {{ $any(admin).name?.length ? $any(admin).name : admin.firstName + ' ' + admin.lastName }}
    </div>
  </div>
</ng-template>
